// import React, { useState } from 'react';
// import { Link } from 'react-router-dom'; // Import the Link component
// import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
// import styles from './authStyles.module.css'
// import logoImage from '../Images/stackFrameWhite.png';

// function SignInComponent() {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');

//   const handleSignIn = async () => {
//     const auth = getAuth();
//     try {
//       await signInWithEmailAndPassword(auth, email, password);
//       console.log("User signed in");
//     } catch (error) {
//       console.error("Error signing in:", error);
//     }
//   }

//   return (
//     <div className={styles.parentContainer}>
//     <div className={styles.container}>
//     <div className={styles.stackFrame}>
//     <img src={logoImage} alt="Your Image" style={{ width: '34px', height: '34px' }} />
//     <span className={styles.stackFrameText}>stackFrame</span>
// </div>
//     <input 
//         className={styles.inputField}
//         type="email" 
//         placeholder="Email" 
//         value={email} 
//         onChange={(e) => setEmail(e.target.value)}
//     />
//     <input 
//         className={styles.inputField}
//         type="password" 
//         placeholder="Password"
//         value={password} 
//         onChange={(e) => setPassword(e.target.value)}
//     />
//     <button className={styles.button} onClick={handleSignIn}>Login</button>
//     <Link to="/signup" className={styles.link}>Don't have an account? Sign up here.</Link>
// </div>
// </div>
//   );
// }

// export default SignInComponent;

// import React, { useState, useEffect } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { getAuth, signInWithEmailAndPassword, signOut } from 'firebase/auth';
// import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore';
// import styles from './authStyles.module.css';
// import logoImage from '../Images/stackFrameWhite.png';

// const Modal = ({ message, onClose }) => (
//   <div className={styles.signUpModal}>
//     <h2>Issue Signing In</h2>
//     <p>{message}</p>
//     <button onClick={onClose}>Close</button>
//   </div>
// );

// function SignInComponent() {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [showModal, setShowModal] = useState(false);
//   const [modalMessage, setModalMessage] = useState('');
//   const navigate = useNavigate();
//   const [userCanNavigate, setUserCanNavigate] = useState(false);

//   useEffect(() => {
//     if (userCanNavigate) {
//       navigate('/dashboard');
//     }
//   }, [userCanNavigate, navigate]);

//   const handleSignIn = async () => {
//     const auth = getAuth();
//     try {
//       const userCredential = await signInWithEmailAndPassword(auth, email, password);
//       const db = getFirestore();
//       const usersRef = collection(db, 'users');
//       const usersQuery = query(usersRef, where('uid', '==', userCredential.user.uid), where('origin', '==', 'stackFrame'));
//       const querySnapshot = await getDocs(usersQuery);

//       if (querySnapshot.empty) {
//         await signOut(auth);
//         setModalMessage("There are no records of this email with stackFrame access in our database, please try signing in with another email or contact support.");
//         setShowModal(true);
//       } else {
//         setUserCanNavigate(true); // Set flag to true to trigger navigation in useEffect
//       }
//     } catch (error) {
//       console.error("Error signing in:", error);
//       await signOut(auth);
//       setModalMessage("Issue Signing In: " + error.message);
//       setShowModal(true);
//     }
//   };

//   return (
//     <div className={styles.parentContainer}>
//       <div className={styles.container}>
//         <div className={styles.stackFrame}>
//           <img src={logoImage} alt="stackFrame Logo" style={{ width: '34px', height: '34px' }} />
//           <span className={styles.stackFrameText}>stackFrame</span>
//         </div>
//         <input 
//             className={styles.inputField}
//             type="email" 
//             placeholder="Email" 
//             value={email} 
//             onChange={(e) => setEmail(e.target.value)}
//         />
//         <input 
//             className={styles.inputField}
//             type="password" 
//             placeholder="Password"
//             value={password} 
//             onChange={(e) => setPassword(e.target.value)}
//         />
//         <button className={styles.button} onClick={handleSignIn}>Login</button>
//         <Link to="/signup" className={styles.link}>Don't have an account? Sign up here.</Link>
//       </div>
//       {showModal && <Modal message={modalMessage} onClose={() => setShowModal(false)} />}
//     </div>
//   );
// }

// export default SignInComponent;
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getAuth, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore';
import styles from './authStyles.module.css';
import logoImage from '../Images/stackFrameWhite.png';

const Modal = ({ message, onClose }) => (
  <div className={styles.signUpModal}>
    <h2>Issue Signing In</h2>
    <p>{message}</p>
    <button onClick={onClose}>Close</button>
  </div>
);

function SignInComponent() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const navigate = useNavigate();
  const [userCanNavigate, setUserCanNavigate] = useState(false);

  useEffect(() => {
    if (userCanNavigate) {
      navigate('/dashboard');
    }
  }, [userCanNavigate, navigate]);

  const handleSignIn = async () => {
    const auth = getAuth();
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const db = getFirestore();
      const usersRef = collection(db, 'users');
      const usersQuery = query(usersRef, where('uid', '==', userCredential.user.uid), where('origin', '==', 'stackFrame'));
      const querySnapshot = await getDocs(usersQuery);

      if (querySnapshot.empty) {
        await signOut(auth);
        setModalMessage("There are no records of this email with stackFrame access in our database, please try signing in with another email or contact support.");
        setShowModal(true);
      } else {
        setUserCanNavigate(true); // Set flag to true to trigger navigation in useEffect
      }
    } catch (error) {
      console.error("Error signing in:", error);
      await signOut(auth);
      setModalMessage("Issue Signing In: " + error.message);
      setShowModal(true);
    }
  };

  return (
    <div className={styles.parentContainer}>
      <div className={styles.container}>
        <div className={styles.stackFrame}>
          <img src={logoImage} alt="stackFrame Logo" style={{ width: '34px', height: '34px' }} />
          <span className={styles.stackFrameText}>stackFrame</span>
        </div>
        <input 
            className={styles.inputField}
            type="email" 
            placeholder="Email" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)}
        />
        <input 
            className={styles.inputField}
            type="password" 
            placeholder="Password"
            value={password} 
            onChange={(e) => setPassword(e.target.value)}
        />
        <button className={styles.button} onClick={handleSignIn}>Login</button>
        <Link to="/signup" className={styles.link}>Don't have an account? Sign up here.</Link>
      </div>
      {showModal && <Modal message={modalMessage} onClose={() => setShowModal(false)} />}
    </div>
  );
}

export default SignInComponent;
